if ( typeof PickupAvailabilityCompact !== 'function' ) {

  class PickupAvailabilityCompact extends HTMLElement {

    constructor(){

      super();
      this.classList.add('active');

      this.storeSelector = document.querySelector('store-selector[data-main-selector]');
      if ( this.storeSelector ) {
        const STORE_CHANGED_EVENT = () => {
          this.fetchAvailability(this.dataset.variantId, true);
        }
        this.storeSelector.addEventListener('storechanged', STORE_CHANGED_EVENT);
				const observer = new MutationObserver(()=>{
          this.storeSelector.removeEventListener('storechanged', STORE_CHANGED_EVENT);
					observer.disconnect();
				});
				observer.observe(this.parentElement, {
					attributes: false, childList: true, subtree: false
				});
      }

      if ( this.hasAttribute('data-static') ) {
        this.fetchAvailability(this.dataset.variantId);
      } else {
        const widgetIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.fetchAvailability(this.dataset.variantId);
        }
        new IntersectionObserver(widgetIntersection.bind(this), {rootMargin: '0px 0px 50px 0px'}).observe(this);
      }
      
    }

    fetchAvailability(variantId, forceFetch = false) {

      const pickupAvailabilityData = this.querySelector('[data-js-pickup-availability-data]');
      if ( pickupAvailabilityData ) {
        this._cachedAvailabilityData = pickupAvailabilityData.cloneNode(true);
      }

      if ( this._cachedAvailabilityData && ! forceFetch ) {
        this.renderPreview(this._cachedAvailabilityData);
      } else if ( this._cachedAvailabilityData && forceFetch && variantId === this.dataset.variantId ) {
        this.renderPreview(this._cachedAvailabilityData);
      } else {

        const variantSectionUrl = `${this.dataset.baseUrl.endsWith('/')?this.dataset.baseUrl:`${this.dataset.baseUrl}/`}variants/${variantId}/?section_id=helper-pickup-availability-compact`;

        fetch(variantSectionUrl)
          .then(response => response.text())
          .then(text => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            if ( sectionInnerHTML ) {
              this._cachedAvailabilityData = sectionInnerHTML.cloneNode(true);
              this.renderPreview(sectionInnerHTML);
            }
          })
          .catch(e => {
            console.log(e);
          });

      }

    }
    
    renderPreview(sectionInnerHTML) {
      
      const selectedStore = localStorage.getItem('selected-store');
      const allStoresEl = sectionInnerHTML.querySelector('.pickup-availability-alert[data-all-available-stores]');
      const availableStores = allStoresEl ? allStoresEl.getAttribute('data-all-available-stores') : '';
      const warehouseAvailable = allStoresEl ? allStoresEl.getAttribute('data-warehouse-available') === 'true' : false;
      let physicalStoreName = (allStoresEl && allStoresEl.getAttribute('data-physical-store')) || '';

      if ( !this.storeSelector ) {
        this.storeSelector = document.querySelector('store-selector[data-main-selector]');
      }

      const selectorPhysicalStores = [];
      if ( this.storeSelector && this.storeSelector.storesList ) {
        for ( const [handle, title] of Object.entries(this.storeSelector.storesList) ) {
          if ( !handle.toLowerCase().includes('warehouse') && !handle.toLowerCase().includes('online') && !title.toLowerCase().includes('warehouse') && !title.toLowerCase().includes('online') && title.toLowerCase() !== 'my store' ) {
            selectorPhysicalStores.push(title);
          }
        }
        if ( !physicalStoreName && selectorPhysicalStores.length > 0 ) {
          physicalStoreName = selectorPhysicalStores.join(', ');
        }
      }

      if ( !physicalStoreName ) {
        physicalStoreName = 'Verdun';
      }

      const formatCanBeShipped = (targetStore) => {
        return (window.KROWN && window.KROWN.settings && window.KROWN.settings.locales && window.KROWN.settings.locales.can_be_shipped_to_store && window.KROWN.settings.locales.can_be_shipped_to_store.includes('{{ store }}'))
          ? window.KROWN.settings.locales.can_be_shipped_to_store.replace('{{ store }}', targetStore)
          : `Can be shipped to ${targetStore}`;
      };

      const canBeShippedLabel = formatCanBeShipped(physicalStoreName);

      const notAvailableLabel = (window.KROWN && window.KROWN.settings && window.KROWN.settings.locales && window.KROWN.settings.locales.not_available_for_pickup)
        ? window.KROWN.settings.locales.not_available_for_pickup
        : 'Not available for pickup';

      if ( selectedStore && (!this.storeSelector || !this.storeSelector.storesList || this.storeSelector.storesList[selectedStore]) ) {
        // search based on selected store 
        let storeFound = false;
        let rawStoreTitle = (this.storeSelector && this.storeSelector.storesList && this.storeSelector.storesList[selectedStore])
          || document.querySelector(`store-selector [data-handle="${selectedStore}"]`)?.dataset.title
          || sectionInnerHTML.querySelector(`.pickup-availability-alert[data-store="${selectedStore}"] .pickup-availability-alert-store`)?.textContent.trim()
          || selectedStore;

        if ( rawStoreTitle.toLowerCase() === 'my store' && physicalStoreName ) {
          rawStoreTitle = physicalStoreName.split(',')[0].trim();
        }
        const storeTitle = rawStoreTitle;

        const isWarehouse = selectedStore.toLowerCase().includes('warehouse') || selectedStore.toLowerCase().includes('online') || storeTitle.toLowerCase().includes('warehouse') || storeTitle.toLowerCase().includes('online');

        if ( isWarehouse ) {
          if ( warehouseAvailable ) {
            this.innerHTML = `<span class="alert alert--circle alert--success">${canBeShippedLabel}</span>`;
          } else {
            this.innerHTML = `<span class="alert alert--circle alert--note">${notAvailableLabel}</span>`;
          }
          storeFound = true;
        } else {
          const storeAlerts = [...sectionInnerHTML.querySelectorAll('.pickup-availability-alert[data-store]:not([data-is-warehouse])')];
          let matchedAlert = storeAlerts.find(elm => elm.dataset.store === selectedStore);
          if ( !matchedAlert ) {
            matchedAlert = storeAlerts.find(elm => selectedStore.includes(elm.dataset.store) || elm.dataset.store.includes(selectedStore));
          }
          if ( !matchedAlert && storeAlerts.length === 1 && selectorPhysicalStores.length <= 1 ) {
            matchedAlert = storeAlerts[0];
          }

          if ( matchedAlert ) {
            const alertEl = matchedAlert.querySelector('.alert');
            this.innerHTML = alertEl ? alertEl.outerHTML.replace('{{ store }}', storeTitle) : matchedAlert.innerHTML.replace('{{ store }}', storeTitle);
            storeFound = true;
          }

          if ( !storeFound ) {
            const defaultUnavailable = sectionInnerHTML.querySelector('.pickup-availability-alert[data-default-unavailable]');
            if ( defaultUnavailable ) {
              const alertEl = defaultUnavailable.querySelector('.alert');
              this.innerHTML = alertEl ? alertEl.outerHTML.replace('{{ store }}', storeTitle) : defaultUnavailable.innerHTML.replace('{{ store }}', storeTitle);
              storeFound = true;
            }
          }
        }

        if ( !selectedStore || !storeFound ) {
          this.innerHTML = '';
        }
      } else {
        // No store selected — show which stores carry this product
        if ( availableStores && availableStores.length > 0 ) {
          // Show "Available at: Store A, Store B"
          const label = (window.KROWN && window.KROWN.settings && window.KROWN.settings.locales && window.KROWN.settings.locales.available_at_stores)
            ? window.KROWN.settings.locales.available_at_stores.replace('{{ stores }}', availableStores)
            : `Available at: ${availableStores}`;
          this.innerHTML = `<span class="alert alert--circle alert--success">${label}</span>`;
        } else if ( warehouseAvailable ) {
          // Product available at warehouse — can be shipped to physical stores
          this.innerHTML = `<span class="alert alert--circle alert--success">${canBeShippedLabel}</span>`;
        } else {
          // Product not available at any store — show "Not available for pickup"
          this.innerHTML = `<span class="alert alert--circle alert--note">${notAvailableLabel}</span>`;
        }
      }

    }
    
  }

  if ( typeof customElements.get('pickup-availability-compact') == 'undefined' ) {
    customElements.define('pickup-availability-compact', PickupAvailabilityCompact);
	}

}
